import { post,get } from '@/utils/request'

export default {
    // 机构列表
    orglist(data) {
        return post('/quality/institution_list/',data)
    },
    // 提交查询
    submit(data) {
        return post('/quality/search_pro/', data)
    },
	// 通过sn查询结果
	searchBySn(data){
		return post('/quality/search_ewm_new/', data)
	},
    // 获取设备列表
    getDev(params) {
        return get('/quality/lists',{params})
    }
}